export default __webpack_public_path__ + "static/media/logo-backup.11150e63.png";